module.exports = __webpack_public_path__ + "static/media/handover.8f86b470.jpg";